import type { Control } from 'react-hook-form';
import { ActionButton, FormTextArea } from '../../../../components/form';
import FaIcon from '../../../../components/icon/FaIcon/FaIcon';
import { faChevronLeft } from '../../../../components/icon/FaIcon/FaIcon';
import { WChanceStaging } from '../../../../components/ui';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type {
  LotteryDeliveryDetailCollection,
  LotteryGoodsCollectionStagingInfo,
  LotteryGoodsDetailCollection,
} from '../../types';
import styles from './CollectionOptionForm.module.scss';

export interface CollectionOptionFormProps {
  goods: LotteryGoodsDetailCollection;
  delivery: LotteryDeliveryDetailCollection;
  collectionId: number;
  createStagingInfo: (stagingKey: string) => LotteryGoodsCollectionStagingInfo;
  variant?: 'default' | 'raffle';
  // フォーム関連のprops
  control: Control<{ note: string }>;
  handleSubmit: (onSubmit: () => void, onError: () => void) => (e: React.FormEvent) => void;
  onSubmit: () => void;
  onError: () => void;
  onBackClick: () => void;
}

function CollectionOptionForm({
  goods,
  createStagingInfo,
  control,
  handleSubmit,
  onSubmit,
  onError,
  onBackClick,
}: CollectionOptionFormProps) {
  const stagingInfo = createStagingInfo(goods.stagingKey);

  return (
    <>
      {/* 特典と演出の出しわけ */}
      {benefitStaging(goods, stagingInfo)}

      {/* 景品名 */}
      <div className={`${utilsStyles.mtSmall}`}>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>{goods.name}</p>
      </div>

      {/* 景品オプション詳細 */}
      <div className={`${utilsStyles.mtSmall}`}>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.textPrewrap}`}>{goods.prizeOptionDescription}</p>
      </div>

      {/* 入力フォーム*/}
      <div className={utilsStyles.mtSmall}>
        <FormTextArea
          label='オプション'
          required
          name='note'
          control={control}
          placeholder='内容を入力してください'
          outlined
        />
        <div className={`${utilsStyles.centeredVertical} ${utilsStyles.mtMedium}`}>
          <ActionButton onClick={handleSubmit(onSubmit, onError) as () => void}>入力を完了する</ActionButton>
        </div>
      </div>

      {/* リンク　*/}
      <div className={`${utilsStyles.mtSmall} ${utilsStyles.centered}`}>
        {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
        <a href='#' onClick={onBackClick}>
          <FaIcon icon={faChevronLeft} />
          &nbsp;獲得した景品へ
        </a>
      </div>
    </>
  );
}

function getRankStyle(rank: number) {
  switch (rank) {
    case 1:
      return styles.rank1;
    case 2:
      return styles.rank2;
    default:
      return '';
  }
}

function benefitStaging(goods: LotteryGoodsDetailCollection, stagingInfo: LotteryGoodsCollectionStagingInfo) {
  if (goods.isRepostCampaign) {
    // リポストキャンペーン特典
    return (
      <div className={styles.repostWrapper}>
        <span className={fontsStyles.montserrat}>リポストキャンペーン</span>
      </div>
    );
  }

  if (goods.benefitMultiDrawCount > 0) {
    // 特典
    return (
      <div className={styles.benefitWrapper}>
        <span className={fontsStyles.montserrat}>{goods.benefitMultiDrawCount}</span>
      </div>
    );
  }
  if (goods.isWchance) {
    // Wチャンス
    return <WChanceStaging size={'large'} />;
  }
  if (stagingInfo.stagingRank) {
    // 演出
    const rank = Number(stagingInfo.stagingRank);

    return (
      <div className={`${styles.stagingRank} ${getRankStyle(rank)}`}>
        <p className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
          {stagingInfo.stagingText}
          <small>賞</small>
        </p>
      </div>
    );
  }

  return <></>;
}

export default CollectionOptionForm;
